import { OrderWithContext } from '@/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component({
  name: 'CmgOrderConfirmationCancelOrder',
})
export default class CmgOrderConfirmationCancelOrder extends Vue {
  currentTime: Moment = moment();
  updateCurrentTimeInterval: NodeJS.Timeout | null = null;

  mounted() {
    this.updateCurrentTimeInterval = setInterval(this.updateCurrentTime, 100);
  }

  unmounted() {
    if (this.updateCurrentTimeInterval !== null) {
      clearInterval(this.updateCurrentTimeInterval);
    }
  }

  @Prop({ required: true, type: Object })
  order!: OrderWithContext

  get displayCancelOrderCountdown() {
    if (typeof this.order.order.orderCancellationCutoffUtc === 'string') {
      const cutOffTime: Moment = moment(this.order.order.orderCancellationCutoffUtc)
      const differenceInSeconds: number = cutOffTime.diff(this.currentTime, "seconds")

      if (differenceInSeconds < 1) {
        return `00:00`;
      } else {
        let minutes: string | number = Math.floor(differenceInSeconds / 60);
        let seconds: string | number = differenceInSeconds - minutes * 60;

        if (minutes < 10) {
          minutes = `0${minutes}`;
        }

        if (seconds < 10) {
          seconds = `0${seconds}`
        }

        return `${minutes}:${seconds}`;
      }
    } else return `00:00`;
  }

  onCancelOrderClick(): void {
    this.$services.ui.setModalVisibility('postSubmitCancelOrder', true);
  }

  private updateCurrentTime(): void {
    this.currentTime = moment();
  }
}
